import { combineReducers } from 'redux';

import session from './session';
import photo from './photo';
import inspectionDetail from './inspectionDetail';
import settings from './settings';
import account from './account';
import providerManagement from './providerManagement';
import editScoring from './editScoring';
import editVisitDetails from './editVisitDetails';
import editPropertyDetails from './editPropertyDetails';
import epcLookup from './epcLookup';
import alerts from './alerts';
import hazardDefects from './hazardDefects';

import * as sessionActions from '../actions/session';

const appReducer = combineReducers({
    models: combineReducers({
        session,
        photo,
    }),
    pages: combineReducers({
        inspectionDetail,
        settings,
        account,
        providerManagement,
        editScoring,
        editVisitDetails,
        editPropertyDetails,
        epcLookup,
        hazardDefects,
    }),
    alerts,
});

const rootReducer = (state, action) => {
    if (action.type === sessionActions.RESET_APP_STATE) {
        // eslint-disable-next-line no-param-reassign
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
